/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import {
    shape, array, object, string, bool, func,
} from 'prop-types';
import Loadable from 'react-loadable';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import SmartGiftContainer from './SmartGiftContainer';
import SmartGiftUIMobile from './SmartGiftUIMobile';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const SmartGiftUIDesktop = Loadable({
    loader: () => import(/* webpackChunkName: "SmartGiftUIDesktopV1" */ './v1/SmartGiftUIDesktop'),
    loading: () => <div />,
});
const SmartGiftUIDesktopV2 = Loadable({
    loader: () => import(/* webpackChunkName: "SmartGiftUIDesktopV2" */ './v2/SmartGiftUIDesktop'),
    loading: () => <div />,
});
const SmartGiftUIDesktopV1Grid = Loadable({
    loader: () => import(/* webpackChunkName: "SmartGiftUIDesktopV1Grid" */ './v1/SmartGiftUIDesktopGrid'),
    loading: () => <div />,
});
const SmartGiftUIDesktopV2Grid = Loadable({
    loader: () => import(/* webpackChunkName: "SmartGiftUIDesktopV2Grid" */ './v2/SmartGiftUIDesktopGrid'),
    loading: () => <div />,
});
const SmartGift = (props) => {
    const {
        pdpVariantName,
        product,
        selectedSku,
        image,
        smartGiftLetThemKnowSection,
        smartGiftAddressSection,
        isPlaEnabled,
        track,
        featureFlags,
    } = props;
    // eslint-disable-next-line
    const { featureFlags: cmcFeatureFlags, presentation_family: presentationFamily = '' } = useContext(CrossMerch);

    const isEnabled = featureFlags['is-smart-gift-enabled'];

    const isPmallPresentation = (product?.brand === 'personalizationmall' || product?.brand === 'thingsremembered') && product?.isSmartgiftEnabled;

    let shouldRenderSmartGift = false;
    if ((isEnabled && product?.isSmartgiftEnabled && !isPlaEnabled) || isPmallPresentation) {
        shouldRenderSmartGift = true;
    }

    const plaSmarGiftEnabled = isPlaEnabled && presentationFamily === 'flower' && featureFlags['is-smartgift-pla-enabled'];

    if (!shouldRenderSmartGift && !plaSmarGiftEnabled) {
        return null;
    }
    track({
        eventCategory: 'Product Page',
        eventAction: 'Smart Gift',
        eventLabel: product.name,
        queued: true,
    });

    return (
        <DesktopMobile
            desktop={() => (
                <SmartGiftContainer>
                    {// eslint-disable-next-line no-nested-ternary
                        featureFlags['is-pdp-v-2-enabled'] ? (
                            featureFlags['is-pdp-grid-enabled'] ? (
                                <SmartGiftUIDesktopV2Grid
                                    giftData={smartGiftLetThemKnowSection}
                                    partNumber={product.partNumber}
                                    productName={product.name}
                                    sku={selectedSku?.id}
                                    price={selectedSku?.prices}
                                    image={image}
                                />
                            ) : (
                                <SmartGiftUIDesktopV2
                                    giftData={smartGiftLetThemKnowSection}
                                    partNumber={product.partNumber}
                                    productName={product.name}
                                    sku={selectedSku?.id}
                                    price={selectedSku?.prices}
                                    image={image}
                                />
                            )
                        ) : (
                            featureFlags['is-pdp-grid-enabled'] ? (
                                <SmartGiftUIDesktopV1Grid
                                    pdpVariantName={pdpVariantName}
                                    giftData={smartGiftLetThemKnowSection}
                                    partNumber={product.partNumber}
                                    productName={product.name}
                                    sku={selectedSku?.id}
                                    price={selectedSku?.prices}
                                    image={image}
                                    isPlaEnabled={isPlaEnabled}
                                />
                            ) : (
                                <SmartGiftUIDesktop
                                    pdpVariantName={pdpVariantName}
                                    giftData={smartGiftLetThemKnowSection}
                                    partNumber={product.partNumber}
                                    productName={product.name}
                                    sku={selectedSku?.id}
                                    price={selectedSku?.prices}
                                    image={image}
                                    isPlaEnabled={isPlaEnabled}
                                />
                            )
                        )
                    }
                </SmartGiftContainer>
            )}
            mobile={() => (
                <SmartGiftContainer>
                    <SmartGiftUIMobile
                        mobileGiftData={smartGiftAddressSection}
                        partNumber={product.partNumber}
                        productName={product.name}
                        sku={selectedSku?.id}
                        price={selectedSku?.prices}
                        image={image}
                        isPlaEnabled={isPlaEnabled}
                        plaSmarGiftEnabled={plaSmarGiftEnabled}
                    />
                </SmartGiftContainer>
            )}
        />
    );
};
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

const mapDispatchToProps = (dispatch) => ({
    track: bindActionCreators(trackEvent, dispatch),
});

SmartGift.propTypes = {
    // from redux
    featureFlags: object.isRequired,
    // from parent
    pdpVariantName: string,
    product: shape({
        partNumber: string.isRequired,
        name: string.isRequired,
    }).isRequired,

    selectedSku: shape({
        id: string.isRequired,
        prices: array.isRequired,
    }).isRequired,

    image: string.isRequired,
    smartGiftLetThemKnowSection: object.isRequired,
    smartGiftAddressSection: object.isRequired,
    isPlaEnabled: bool.isRequired,
    track: func,
};

SmartGift.defaultProps = {
    pdpVariantName: '',
    track: () => { },
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(SmartGift);
